export const PaymentMethod = {
    megapay: '1',
    bank_transfer: '2'
};
const EXCEPT_PROVINCES = {
    HP: 7,
    QN: 18,
    HD: 21,
    HY: 24
};
const HCROUTES = {
    home: '',
    schedule: 'schedule',
    payment: 'payment',
    payment_result: 'payment-result',
    order: 'order',
};

export { HCROUTES, EXCEPT_PROVINCES };
